import {TipoPuntoVentaEnum} from '../enums/tipo-punto-venta-enum';

export interface CorporativoRegistro {
  label: string;
  codigo: string;
  pais: string;
  puntoVenta: string;
  tipoPuntoVenta: number;
}

export const CORPORATIVOS_REGISTRO: CorporativoRegistro[] = [
  {
    label: 'F000 - Corporativo',
    codigo: 'F000',
    pais: 'SC',
    puntoVenta: 'F000',
    tipoPuntoVenta: TipoPuntoVentaEnum.Corporativo
  },
  {
    label: 'PE00 - Perú',
    codigo: 'PE00',
    pais: 'PE',
    puntoVenta: 'PE00',
    tipoPuntoVenta: TipoPuntoVentaEnum.Corporativo
  },
  {
    label: 'FP00 - Perú Fraiche',
    codigo: 'FP00',
    pais: 'FP',
    puntoVenta: 'FP00',
    tipoPuntoVenta: TipoPuntoVentaEnum.Corporativo
  },
  {
    label: 'CO00 - Colombia',
    codigo: 'CO00',
    pais: 'CO',
    puntoVenta: 'CO00',
    tipoPuntoVenta: TipoPuntoVentaEnum.Corporativo
  },
  {
    label: 'VU00 - México VIPAIGUA',
    codigo: 'VU00',
    pais: 'VU',
    puntoVenta: 'VU00',
    tipoPuntoVenta: TipoPuntoVentaEnum.Corporativo
  },
  {
    label: 'F000 - México FRAICHE',
    codigo: 'F000',
    pais: 'MX',
    puntoVenta: 'F000',
    tipoPuntoVenta: TipoPuntoVentaEnum.Corporativo
  }
];
